import Backbone from "backbone";

import AutoRefetchingModel from "models/AutoRefetchingModel";
import * as splitTest from "splitTest";

interface StreakJSON {
  days: number;
  repairableDays: number;
  todayStats: {
    goalMet: boolean;
    fractionOfGoalMet: number;
    wordsRead: number;
    wordsPracticed: number;
    byLanguage: {
      [language: string]: {
        wordsRead: number;
        wordsPracticed: number;
      };
    };
  };
}

/** This model just reads data from the server, it doesn't write. */
class StreakModel extends AutoRefetchingModel<StreakJSON> {
  url = () => "/api/userLearningLog/streak";

  constructor(attributes?: StreakJSON, options?: Backbone.ModelSetOptions) {
    super(attributes, options);

    this.on("change:todayStats", async () => {
      const previous = this.previous("todayStats");
      const current = this.get("todayStats");
      if (previous?.goalMet === false && current?.goalMet === true) {
        splitTest.trackEventWithProperties("streakGoalMet", {
          days: this.get("days"),
          wordsRead: current.wordsRead,
          wordsPracticed: current.wordsPracticed,
        });
      }
    });
  }
}

export default StreakModel;
